/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllServiceContentResponseDto } from '../model/allServiceContentResponseDto';
import { ServiceContentResponseDto } from '../model/serviceContentResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceContentService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentGetAllServiceContentGet(observe?: 'body', reportProgress?: boolean): Observable<AllServiceContentResponseDto>;
    public apiServiceContentGetAllServiceContentGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllServiceContentResponseDto>>;
    public apiServiceContentGetAllServiceContentGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllServiceContentResponseDto>>;
    public apiServiceContentGetAllServiceContentGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllServiceContentResponseDto>('get',`${this.basePath}/api/ServiceContent/getAllServiceContent`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceContentGetServiceContentByServiceIdServiceIdGet(serviceId: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceContentResponseDto>;
    public apiServiceContentGetServiceContentByServiceIdServiceIdGet(serviceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceContentResponseDto>>;
    public apiServiceContentGetServiceContentByServiceIdServiceIdGet(serviceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceContentResponseDto>>;
    public apiServiceContentGetServiceContentByServiceIdServiceIdGet(serviceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling apiServiceContentGetServiceContentByServiceIdServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceContentResponseDto>('get',`${this.basePath}/api/ServiceContent/getServiceContentByServiceId/${encodeURIComponent(String(serviceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
